import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-refresh-icon',
  templateUrl: './lib-refresh-icon.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibRefreshIconComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
